<template>
    <rkm-overlay>
        <rkm-layout-body title="Consulta de estoque">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/consulta-estoque/List'

export default {
    components: { List },
}
</script>